define(function(require) {
    const Cell = require('../BaseCell');
    const _ = require('underscore');

    /**
     * Formats as an icon
     * @param {Object} options
     * @returns column definition
     */
    const IconCell = function(options) {
        return {
            CellClass: Cell,
            options: _.extend(
                {
                    className: 'dt-body-center text-center',
                    iconClass: function(data, row) {
                        return data;
                    },
                    type: 'string',
                    onDisplay: (data, type, row, meta, translatedValue) => {
                        const iconClass = options.iconClass(data, row);
                        return _.template(/*template */ `<i class="data-grid__cell--icon <%- iconClass %>"/>`)({
                            iconClass: iconClass
                        });
                    }
                },
                options
            )
        };
    };
    return IconCell;
});
